import { Component, input } from '@angular/core';

import { CmsPicture } from '@fcom/core-api';
import { AspectRatios, FetchPriorityEnum } from '@fcom/ui-components/components/images/enums';

@Component({
  selector: 'fin-text-on-image-no-link',
  styleUrls: ['./text-on-image-no-link.component.scss'],
  templateUrl: './text-on-image-no-link.component.html',
  standalone: false,
})
export class TextOnImageNoLinkComponent {
  protected readonly FetchPriorityEnum = FetchPriorityEnum;

  teaserTitle = input<string>();
  teaserText = input<string>();
  imageData = input<CmsPicture>();
  imageAspectRatio = input<keyof typeof AspectRatios>();
}
